import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReactToPrint from "react-to-print";
//import Escudo from "../../../assets/Escudo.jpg";

const componentRef = React.createRef();
var QRCode = require("qrcode.react");

class CertificadoNM extends React.Component {
  render() {
    return (
      <Modal isOpen={this.props.modalLicencia} modalClassName="modal-message">
        <ModalHeader>
          <div>
            Folio de Licencia: {this.props.licencia.folio_solicitud}
            <button
              type="button"
              className="close"
              onClick={this.props.change}
              style={{ position: "fixed", right: "21%" }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className={this.props.working ? "" : "hide"}>
            <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
              CARGANDO INFORMACIÓN
            </div>
          </div>

          <div className={this.props.working ? "hide" : ""}>
            <div
              className="row"
              ref={componentRef}
              style={{ background: "white" }}
            >
              {/*Aqui se muestra licencia******************************************************/}

              <form
                style={{
                  marginRight: "13%",
                  marginLeft: "13%",
                  color: "black",
                }}
              >
                {/*"C:\Users\celes\Documents\GitHub\sinaip\client\public\assets\Escudo.jpg" */}
                <div style={{ textAlign: "left", margin: "3%" }}>
                  <table style={{ width: "100%", tableLayout: "auto" }}>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "left", color: "black" }}>
                          <img
                            src="../assets/Escudo.jpg"
                            width="100"
                            height="100"
                          />
                        </td>
                        <td style={{ textAlign: "right", color: "black" }}>
                          <img
                            src="../assets/1631027847767_Logo IPSA.png"
                            width="200"
                            height="100"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="75%">
                          <h5
                            style={{
                              textAlign: "right",
                              marginRight: "15%",
                              color: "black",
                            }}
                          >
                            Constancia No. {this.props.licencia.folio_solicitud}
                          </h5>
                        </td>
                        <td width="25%">
                          <div
                            style={{
                              textAlign: "right",
                              margin: "8%",
                              color: "black",
                            }}
                          >
                            <QRCode
                              size="100"
                              value={
                                "id: " +
                                this.props.licencia.notable_id +
                                "\n" +
                                "Folio: " +
                                this.props.licencia.folio_solicitud +
                                "\n" +
                                "Fecha de emisión:" +
                                this.props.licencia.fecha_aprueba_sinaip
                              }
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p style={{ textAlign: "justify" }}>
                  {/*  {this.props.licencia.texto}{" "} */}
                  El suscrito Director de Salud Animal (DISAAN), del Instituto
                  de Protección y Sanidad Agropecuaria (IPSA), hace constar que
                  la Empresa denominada:{" "}
                  <b>{this.props.licencia.razon_social}</b> de origen{" "}
                  <b>{this.props.licencia.pais_texto}</b>, ha cumplido con los
                  requisitos de ley para realizar:{" "}
                  <b>{this.props.licencia.anotacion_marginal}</b> de conformidad a lo
                  establecido en la Ley No. 291 “Ley Básica de Salud Animal y
                  Sanidad Vegetal” y Ley No. 274 “Ley Básica para la Regulación
                  y Control de Plaguicidas, Sustancias Tóxicas, Peligrosas y
                  Otras Similares”.
                </p>

                <p>
                  <b>Representantes legales:</b>{" "}
                  {this.props.licencia.representantes}
                </p>
                <p>
                  <b>Regentes:</b> {this.props.licencia.regentes}
                </p>
                <p>
                  <b>Actividad:</b> {this.props.licencia.actividad}
                </p>
                <p>
                  Se extiende el presente en Managua, Nicaragua del día{" "}
                  {this.props.licencia.fecha_emision}
                </p>
                {/* this.props.licencia.firma !== null? 
                  <img
                    style={{ textAlign: "center", margin: "8%" }}
                    src={this.props.licencia.firma}
                  />
                  : null*/}
                <p
                  style={{
                    textAlign: "center",
                    margin: "8%",
                    marginTop: "15em",
                  }}
                >
                  <center>
                    <div
                      style={{ borderBottom: "1px solid #333", width: "50%" }}
                    ></div>
                    <div>{this.props.licencia.nombre_firma} Nombre Director</div>
                  </center>
                  Director DISAAN
                </p>
              </form>
            </div>
            <hr />
          </div>
        </ModalBody>
        <ModalFooter>
          <ReactToPrint
            content={() => componentRef.current}
            pageStyle=""
            trigger={() => (
              <button id="btn-imprimir" className="btn btn-primary m-r-5">
                Imprimir
              </button>
            )}
            onBeforeGetContent={() =>
              this.props.imprimir(
                this.props.licencia.notable_id,
                this.props.licencia.impresiones
              )
            }
          />
          <button className="btn btn-danger" onClick={this.props.change}>
            Regresar
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
export default CertificadoNM;
